import React from 'react'
import { Label } from 'components/generic/Input/TextInput'
import { InputLabelText } from 'components/generic/Input/styles'
import { TextArea, Description } from './styles'

const TextAreaInput = React.forwardRef(({ label = '', subLabel, isValid = true, ...rest }, ref) => {
  return (
    <Label>
      <InputLabelText>{label}</InputLabelText>
      {subLabel && <Description>{subLabel}</Description>}
      <TextArea isValid={isValid} ref={ref} {...rest} />
    </Label>
  )
})

// Need this to get around false positive lint issue
// see https://github.com/yannickcr/eslint-plugin-react/issues/2269
TextAreaInput.displayName = 'TextAreaInput'

export default TextAreaInput
